import moment from 'moment';
import * as i18next from 'i18next';
import { G2S } from '../g2s';
import * as api from '../api';
import * as utils from '../utils';

export class PaymentTypeModel {
    paymentTypeId: string;
    kind: string;
    commission: number;
    isDirectPayment: boolean;
    paymentTypeOptions: any;
    paymentMethod?: any;
    paymentMethods?: any;
    selected: boolean;
    isYandexPay?: boolean;

    constructor(paymentType: api.PaymentTypeDesc) {
        this.paymentTypeId = paymentType.paymentTypeId;
        this.kind = paymentType.kind;
        this.commission = paymentType.commission;
        this.isDirectPayment = paymentType.isDirectPayment;
        this.paymentTypeOptions = paymentType.paymentTypeOptions;
        this.paymentMethods = paymentType.paymentMethods;
        this.selected = false;
    }
}

export class CardModel {
    holder = '';
    number = '';
    expiry = ''; // string used because of timezone problems with Date
    code = '';
}

export class YandexPaymentData {
    env = G2S.config.environment !== 'Production' ? (<any>window).YaPay.PaymentEnv.Sandbox : '';
    version = 2;
    countryCode = (<any>window).YaPay?.CountryCode.Ru;
    currencyCode = (<any>window).YaPay?.CurrencyCode.Rub;
    merchant = {
        id: '',
        name: '',
        url: ''
    };
    order = {
        id: '',
        total: {
            amount: ''
        }
    };
    paymentMethods = [
        {
            type: (<any>window).YaPay.PaymentMethodType.Card,
            gateway: '',
            gatewayMerchantId: '',
            allowedAuthMethods: [(<any>window).YaPay.AllowedAuthMethod.PanOnly],
            allowedCardNetworks: [
                (<any>window).YaPay.AllowedCardNetwork.Visa,
                (<any>window).YaPay.AllowedCardNetwork.Mastercard,
                (<any>window).YaPay.AllowedCardNetwork.Mir,
                (<any>window).YaPay.AllowedCardNetwork.Maestro,
                (<any>window).YaPay.AllowedCardNetwork.VisaElectron
            ]
        }
    ];
    constructor(merchant: any, order: any, bookingSessionId: number) {
        this.merchant = {
            // id: merchant.ypMerchantId,
            id: 'fc143448-b787-4aa1-819f-1baf06e85cf4',
            // name: merchant.ypMerchantName,
            name: 'mego_travel_plus',
            url: merchant.ypMerchantUrl
        };
        this.paymentMethods[0].gateway = merchant.ypGateway;
        this.paymentMethods[0].gatewayMerchantId = merchant.ypGatewayMerchantId.toString();
        this.order = {
            id: bookingSessionId.toString(),
            total: { amount: Math.round(order).toString() }
        };
        console.log(this.order.total.amount);
        
    }
}

export class PaymentModel {
    bonusAmount = 0;

    card: CardModel = new CardModel();

    paymentTypes: PaymentTypeModel[] = [];

    paymentMethod: any;

    selectedPaymentTab = '';

    selectedPaymentTypeId = '';

    constructor(paymentTypes: api.PaymentTypeDesc[]) {
        paymentTypes.forEach(pt => {
            this.paymentTypes.push(new PaymentTypeModel(pt));
        });

        this.initPaymentTab();

        this.preloadExternalScripts();
    }

    getPaymentMethod() {
        return true;
    }

    getCardWithEncryptedPacket(): api.CreditCard | null {
        const mCardExpiry = moment(this.card.expiry);

        const result: api.CreditCard = {
            cardHolderName: this.card.holder,
            cardNumber: this.card.number,
            cardExpMonth: parseInt(mCardExpiry.format('MM')),
            cardExpYear: parseInt(mCardExpiry.format('YY')),
            cardCvv: this.card.code
        };

        // Skip encrypted packet for test cards
        const n = utils.String.normalizeNumber(this.card.number);
        if (n === '4111111111111111'
            || n === '5105105105105122'
            || n === '4111111111111115'
            || n === '4111111111111116'
            || n === '4111111111111117'
            || n === '4111111111111118'
            || n === '4111111111111119'
            || n === '4222222222222221'
            || n === '4222222222222220'
            || n === '5555555555554444'
            || n === '5105105105105100') {
            return result;
        }

        if (this.selectedPaymentType
            && this.selectedPaymentType.paymentTypeOptions != null
            && this.selectedPaymentType.paymentTypeOptions.mobiMmUuid != null
            && this.selectedPaymentType.paymentTypeId !== 'MobiMoneySbp'
        ) {
            if ((<any>window).mm) {
                const form: HTMLFormElement = window.document.createElement('form');

                this.appendMobiFormInput(form, 'cardNumber', this.card.number);
                this.appendMobiFormInput(form, 'name', this.card.holder);
                this.appendMobiFormInput(form, 'expDateMonth', mCardExpiry.format('MM'));
                this.appendMobiFormInput(form, 'expDateYear', mCardExpiry.format('YYYY'));
                this.appendMobiFormInput(form, 'cvv', this.card.code);

                try {
                    const cryptogram = new (<any>window).mm.EncodeScript(this.selectedPaymentType.paymentTypeOptions.mobiMmUuid, form).makeCryptogram();

                    if (cryptogram && cryptogram.packet) {
                        result.encryptedPacket = cryptogram.packet;
                    } else {
                        // MobiMoney cryptogram required!
                        return null;
                    }
                }
                catch (error) {
                    G2S.logError(error.message);

                    return null;
                }
            }
            else {
                // MobiMoney script not loaded - error! MobiMoney cryptogram is required!
                return null;
            }
        }

        return result;
    }

    get selectedPaymentType(): PaymentTypeModel {
        let selectPayment = utils.find(this.paymentTypes,
            (item: PaymentTypeModel) => {
                return item.paymentTypeId === this.selectedPaymentTypeId;
            });
        // crutch for yandexPay
        if (this.selectedPaymentTab === 'yandexpay') {
            selectPayment = { ...selectPayment, isYandexPay: true, paymentMethod: {} };
        }
        return selectPayment;
    }

    get selectedPaymentMethod(): any | null {
        if (this.selectedPaymentType.paymentMethods && this.selectedPaymentType.paymentMethods.length) {
            return this.selectedPaymentType.paymentMethods[0];
        }
        return null;
    }

    get paymentButtonLabel(): string {
        switch (this.selectedPaymentTab) {
            case 'later':
                return i18next.t('button_book');
            case 'credit':
                return i18next.t('button_buy');
            default:
                return i18next.t('button_pay');
        }
    }

    get paymentTypeCard(): PaymentTypeModel | null {
        if (this.paymentTypes) {
            return utils.find(this.paymentTypes, (item: PaymentTypeModel) => {
                return item.kind === 'CreditCard' || item.kind === 'CreditCardInplace';
            });
        }

        return null;
    }

    compareVersion(minVersion: string, comparable: string): boolean {
        const minVersionComponent = minVersion.split('.').map(Number);
        const comComponent = comparable.split('.').map(Number);

        if (minVersionComponent.length < 3) {
            return Number(minVersion) <= Number(comComponent);
        } else {
            for (let i = 0; i < Math.max(minVersionComponent.length, comComponent.length); i++) {
                const curValue = minVersionComponent[i] || 0;
                const comValue = comComponent[i] || 0;
                
                if (curValue < comValue) {
                    return true;
                } else if (curValue > comValue) {
                    return false;
                }
            }
        }

        return true;
    }

    get paymentTypeSbp(): PaymentTypeModel | null {
        console.log('paymentTypeSbp');
        const urlQuery = utils.Http.getUrlParameters();
        
        if ((urlQuery['mobile'] !== 'android' && urlQuery['mobile'] !== 'iphone' && !!this.paymentTypes)
            || (urlQuery['mobile'] == 'android' && urlQuery['appVersion'] && this.compareVersion('5.43.0', urlQuery['appVersion']))
            || (urlQuery['mobile'] == 'iphone' && urlQuery['appVersion'] && this.compareVersion('7.42.0', urlQuery['appVersion']))) {
            return utils.find(this.paymentTypes, (item: PaymentTypeModel) => {
                return item.paymentTypeId === 'MobiMoneySbp';
            });
        }

        return null;
    }

    get paymentTypeCredit(): PaymentTypeModel | null {
        if (this.paymentTypes) {
            return utils.find(this.paymentTypes, (item: PaymentTypeModel) => {
                return item.kind === 'Credit';
            });
        }

        return null;
    }

    get paymentTypesEmoney(): PaymentTypeModel[] {
        if (this.paymentTypes) {
            return this.paymentTypes.filter((item: PaymentTypeModel) => {
                return item.kind === 'EMoney';
            });
        }

        return [];
    }

    get paymentTypePartnerCash(): PaymentTypeModel | null {
        if (this.paymentTypes) {
            return utils.find(this.paymentTypes, (item: PaymentTypeModel) => {
                return item.paymentTypeId === 'PartnerCash';
            });
        }

        return null;
    }

    get paymentTypePayLater(): PaymentTypeModel | null {
        if (this.paymentTypes) {
            return utils.find(this.paymentTypes, (item: PaymentTypeModel) => {
                return item.kind === 'PayLater';
            });
        }

        return null;
    }

    get paymentTypeMoneywall(): PaymentTypeModel | null {
        if (this.paymentTypes) {
            return utils.find(this.paymentTypes, (item: PaymentTypeModel) => {
                return item.paymentTypeId === 'Moneywall';
            });
        }

        return null;
    }

    get paymentTypeYandexPay(): PaymentTypeModel | null {
        if (this.paymentTypes) {
            return utils.find(this.paymentTypes, (item: PaymentTypeModel) => {
                return item.paymentTypeId === 'MobiMoneyCard' && item.paymentMethods && item.paymentMethods!.length > 0 && window['YaPay'];
            });
        }

        return null;
    }

    get showPaymentTabs(): boolean {
        let tabCount = 1; // Вернуть 0, если попросят скрывать панель выбора оплаты

        if (this.paymentTypes) {
            if (this.paymentTypeCard) {
                tabCount++;
            }

            if (this.paymentTypesEmoney.length > 0) {
                tabCount++;
            }

            if (this.paymentTypeCredit) {
                tabCount++;
            }

            if (this.paymentTypePayLater) {
                tabCount++;
            }

            if (this.paymentTypeMoneywall) {
                tabCount++;
            }

            if (this.paymentTypeYandexPay) {
                tabCount++;
            }

            if (this.paymentTypeSbp) {
                tabCount++;
            }
        }

        return tabCount > 1;
    }

    public calculateAvailableBonuses(orderTotal: number, userBonuses: api.UserBonuses): number {
        let result = userBonuses.status.currentBalance;
        const bonusMaxValue = Math.round(orderTotal * userBonuses.bonusMaxPercentLimitPerOrder / 100);

        if (result > bonusMaxValue) {
            result = bonusMaxValue;
        }

        if (result > userBonuses.bonusMaxLimitPerOrder) {
            result = userBonuses.bonusMaxLimitPerOrder;
        }

        return result;
    }

    public onSelectedPaymentTabChanged() {
        switch (this.selectedPaymentTab) {
            case 'card':
                this.selectedPaymentTypeId = this.paymentTypeCard!.paymentTypeId;
                break;
            case 'credit':
                this.selectedPaymentTypeId = this.paymentTypeCredit!.paymentTypeId;
                break;
            case 'emoney':
                this.selectedPaymentTypeId = this.paymentTypesEmoney[0].paymentTypeId;
                break;
            case 'later':
                this.selectedPaymentTypeId = this.paymentTypePayLater!.paymentTypeId;
                break;
            case 'moneywall':
                this.selectedPaymentTypeId = this.paymentTypeMoneywall!.paymentTypeId;
                break;
            case 'yandexpay':
                this.selectedPaymentTypeId = this.paymentTypeYandexPay!.paymentTypeId;
                break;
            case 'sbp':
                this.selectedPaymentTypeId = this.paymentTypeSbp!.paymentTypeId;
                break;
        }
    }

    private appendMobiFormInput(form: HTMLFormElement, attr: string, value: any) {
        const input: HTMLInputElement = window.document.createElement('input');
        input.setAttribute('value', value);
        input.setAttribute('data-mm', attr);
        form.appendChild(input);
    }

    private initPaymentTab() {
        if (this.paymentTypeCard) {
            this.selectedPaymentTab = 'card';
            this.selectedPaymentTypeId = this.paymentTypeCard.paymentTypeId;
        }

        if (!this.selectedPaymentTab
            && this.paymentTypesEmoney.length > 0) {
            this.selectedPaymentTab = 'emoney';
            this.selectedPaymentTypeId = this.paymentTypesEmoney[0].paymentTypeId;
        }

        if (!this.selectedPaymentTab
            && this.paymentTypeSbp) {
            this.selectedPaymentTab = 'sbp';
            this.selectedPaymentTypeId = this.paymentTypeSbp.paymentTypeId;
        }

        if (!this.selectedPaymentTab
            && this.paymentTypeCredit) {
            this.selectedPaymentTab = 'credit';
            this.selectedPaymentTypeId = this.paymentTypeCredit.paymentTypeId;
        }

        if (!this.selectedPaymentTab
            && this.paymentTypePartnerCash) {
            this.selectedPaymentTab = 'partner';
            this.selectedPaymentTypeId = this.paymentTypePartnerCash.paymentTypeId;
        }

        if (!this.selectedPaymentTab
            && this.paymentTypePayLater) {
            this.selectedPaymentTab = 'later';
            this.selectedPaymentTypeId = this.paymentTypePayLater.paymentTypeId;
        }
    }

    private preloadExternalScripts() {
        const ptc = this.paymentTypeCard;

        if (ptc
            && ptc.paymentTypeOptions != null
            && ptc.paymentTypeOptions.mobiClientScript != null) {
            utils.loadScript(
                ptc.paymentTypeOptions.mobiClientScript,
                function () {
                    setTimeout(function () {
                        if (!(<any>window).mm) {
                            G2S.logError('mobiClientScript: external script not initialized #1.');
                        }
                    }, 500);
                },
                function () {
                    G2S.logError('mobiClientScript load failed #1. Trying again...', 'WARNING');

                    utils.loadScript(
                        ptc!.paymentTypeOptions.mobiClientScript,
                        function () {
                            setTimeout(function () {
                                if (!(<any>window).mm) {
                                    G2S.logError('mobiClientScript: external script not initialized #2.');
                                }
                            }, 500);
                        },
                        function () {
                            G2S.logError('mobiClientScript load failed #2.', 'WARNING');
                        });
                });
        }
    }
}
